import 'intersection-observer';

export default class CurrentNav {

    constructor($nav, sections) {
        this.$nav = $nav;
        this.sections = sections;
        this.collection = [];
        this.currentInd = 0;
        this.setNav(this.currentInd);

        const options = {
            "rootMargin": '-50% 0px'
        };
        this.observer = new IntersectionObserver((entries, object) => {
            //callback
            let _this = this;
            let n = 0;
            entries.forEach(function (entry, i) {
                //交差していない場合終了
                if (!entry.isIntersecting) return;
                //交差対象オブジェクト
                const tgt = entry.target;
                //コレクション
                //tgt.classList.remove("ef-scroll");
                let index = _this.getIndex(tgt);

                if(DIR_ID == 'stresskeigen') {

                    if(index<4){
                        _this.setNav(index);
                    }
                    if(index>0 && index <= 3){
                        if(index===2){
                            _this.$nav.removeClass("is-red");
                        } else {
                            _this.$nav.addClass("is-red");
                        }
                    } else if(index>3) {
                        _this.$nav.removeClass("is-red");
                    } else {
                        _this.$nav.removeClass("is-red");
                    }

                } else if (DIR_ID == 'ketsuatsutakame') {

                    if(index<4){
                        _this.setNav(index);
                    }
                    if(index>0 && index <= 2){
                        if(index===2){
                            _this.$nav.removeClass("is-blue");
                        } else {
                            _this.$nav.addClass("is-blue");
                        }
                    } else if(index>2) {
                        _this.$nav.removeClass("is-blue");
                    } else {
                        _this.$nav.removeClass("is-blue");
                    }

                }

                //監視対象から除外
                //object.unobserve(tgt);

            })
        }, options);

        this.sections.forEach(($section) => {
            this.observer.observe($section[0]);
        })

    }

    setNav(nextIndex) {
        this.$nav.eq(this.currentInd).removeClass("is-current");
        this.$nav.eq(nextIndex).addClass("is-current");
        this.currentInd = nextIndex;
    }

    getIndex(tgt) {
        for (let i = 0; i < this.sections.length; i++) {

            if (this.sections[i][0] === tgt) {
                return i;
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/scripts/CurrentNav.js